export default __webpack_public_path__ + "static/media/IMG_6801.cf8dc3f8.jpeg";